module.exports = __webpack_public_path__ + "img/13.cef4a7be.jpg";